import { ref, watch, onMounted, onUnmounted } from 'vue';

export function useAutoSave(saveKey, data, saveCallback, options = {}) {
  const {
    debounceTime = 2000,
    autoLoad = true,
    loadCallback = null
  } = options;

  const autoSaveStatus = ref('idle'); // idle, saving, saved, error
  const lastSavedTime = ref(null);
  let debounceTimer = null;

  // 加载数据
  const loadData = () => {
    try {
      const saved = localStorage.getItem(saveKey);
      if (saved && loadCallback) {
        const parsed = JSON.parse(saved);
        loadCallback(parsed);
        autoSaveStatus.value = 'loaded';
        return true;
      }
    } catch (e) {
      console.error('加载自动保存数据失败:', e);
    }
    return false;
  };

  // 保存数据
  const saveData = async () => {
    if (debounceTimer) {
      clearTimeout(debounceTimer);
    }

    autoSaveStatus.value = 'saving';

    debounceTimer = setTimeout(async () => {
      try {
        if (saveCallback) {
          await saveCallback();
        }
        localStorage.setItem(saveKey, JSON.stringify(data.value));
        lastSavedTime.value = new Date();
        autoSaveStatus.value = 'saved';
      } catch (e) {
        console.error('自动保存失败:', e);
        autoSaveStatus.value = 'error';
      }
    }, debounceTime);
  };

  // 清除自动保存数据
  const clearAutoSave = () => {
    try {
      localStorage.removeItem(saveKey);
      if (debounceTimer) {
        clearTimeout(debounceTimer);
      }
      autoSaveStatus.value = 'idle';
    } catch (e) {
      console.error('清除自动保存数据失败:', e);
    }
  };

  // 监听数据变化
  let stopWatch = null;
  if (data) {
    stopWatch = watch(data, saveData, { deep: true });
  }

  onMounted(() => {
    if (autoLoad) {
      loadData();
    }
  });

  onUnmounted(() => {
    if (debounceTimer) {
      clearTimeout(debounceTimer);
    }
    if (stopWatch) {
      stopWatch();
    }
  });

  return {
    autoSaveStatus,
    lastSavedTime,
    saveData,
    loadData,
    clearAutoSave
  };
}
